export type SpinnerType = `${MktSpinnerTypes}`;
export type SpinnerSize = `${MktSpinnerSizes}`;

export enum MktSpinnerTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum MktSpinnerSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big',
}

export interface MktSpinnerProps {
  size: SpinnerSize;
  type?: SpinnerType;
  color?: string;
  className?: string;
}
